import React from 'react';

/*
## Props object for TooltipMC

className: optional
  - String that will be added to the component classes.

title: optional
  - String that will be displayed a title.

children: required
  - React element that will trigger the tooltip.

*/

const CardContainerMC = ({
  children,
  title,
  titleClassName,
  className,
  customContentClasses = ''
}) => {
  const containerClasses = [
    'tw-w-full',
    'tw-px-4',
    'tw-bg-white',
    'tw-mt-6',
    'tw-rounded-lg',
    'tw-py-6'
  ].join(' ');

  const contentClasses = [
    'tw-w-full',
    'tw-min-w-0',
    'tw-flex',
    'tw-flex-nowrap',
    'tw-justify-self-center',
    'tw-items-center'
  ].join(' ');

  return (
    <div className={`${containerClasses} ${className || ''}`}>
      {title
      && (
      <div className={titleClassName ? titleClassName : 'tw-text-lg tw-font-bold tw-text-gray-800 tw-mb-4'}>
        {title}
      </div>
      )}
      <div className={customContentClasses ? customContentClasses : contentClasses}>
        {children}
      </div>
    </div>
  );
};

export default CardContainerMC;
